import { unionState } from "@common/store/helpers"
import qs from "qs"

const state = () => ({
  items: [],
  related: [],
})

const actions = {
  async fetchAll({ commit }, params) {
    const response = await axios.get(`/products/search`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    commit("storeItems", response.data.items)
    return response.data
  },

  async fetch({ commit }, id) {
    const response = await axios.get(`/products/${id}`)
    commit("storeItem", response.data)
    return response.data
  },

  async fetchBySlug({ commit }, slug) {
    const response = await axios.get(`/products/search`, {
      params: { slug },
    })
    commit("storeItems", response.data.items)
    return response.data.items[0]
  },

  async fetchRelated({ commit }, { id, params }) {
    const response = await axios.get(`/products/${id}/related`, { params })
    commit("storeRelated", response.data)
    return response.data
  },
}

const mutations = {
  storeItems(state, items) {
    state.items = unionState(state.items, items)
  },
  storeItem(state, item) {
    state.items = unionState(state.items, [item])
  },

  storeRelated(state, items) {
    state.related = items
  },
}

const getters = {
  getById: (state) => (id) => state.items.find((p) => p.id === id),
  getBySlug: (state) => (slug) => state.items.find((p) => p.slug === slug),
  getByCategory: (state) => (category) =>
    state.items.filter((p) => p.category === category),
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
